import { Grid, Tab, Tabs } from '@material-ui/core';
import React, { Component } from 'react'

export default class OTBComponent extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = { ...this.state, activeTab: 1 };
    }

    handleChangeTab = (event, newValue) => {
        this.setState({ activeTab: newValue })
    }

    render() {


        var content = <div>none</div>
        switch (this.state.activeTab) {
            case 1:
                content = 'Kumulativní vývoj';
                break;
            case 2:
                content = 'Přírůstkový vývoj';
                break;
        }



        return (
            <Grid
                container
            >
                <Grid item xs={12}>
                    <Tabs
                        value={this.state.activeTab}
                        indicatorColor="primary"
                        textColor="primary"
                        onChange={this.handleChangeTab}
                        aria-label="disabled tabs example"
                    >
                        <Tab value={1} label="Kumulativní vývoj" />
                        <Tab value={2} label="Přírůstkový vývoj" />
                    </Tabs>
                </Grid>
                <Grid xs={12} item>
                    <Grid xs={12} container>
                        {content}
                    </Grid>
                </Grid>
            </Grid>

        );
    }
}
